import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Services.scss';

import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import Service from '../../components/Service';

const Work = () => {
  // states
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);

  // Effects hook
  useEffect(() => {
    const query = '*[_type == "services"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        Overview of Available <span>Services</span>
      </h2>
      <h3 className="subhead-text">Solutions</h3>

      {/* <div className="app__work-filter">
        {['ALL', 'Next.js', 'MERN Web-App', 'Landing Page', 'UI/UX'].map(
          (item, index) => (
            <>
              <div
                key={index + 101}
                onClick={() => handleWorkFilter(item)}
                className={`app__work-item app__flex p-text ${
                  activeFilter === item ? 'item-active' : ''
                }`}
              >
                {item}
              </div>
            </>
          )
        )}
      </div> */}

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-protfolio"
      >
        {filterWork.map((work) => {
          return (
            <Service
              key={work._id}
              id={work._id}
              imgUrl={work.imgUrl}
              title={work.title}
              description={work.description}
            />
          );
        })}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg'
);
